import PropTypes from "prop-types";

import { DropdownInput } from "../../../../../../../../components";
import { LogsTableDropdownWrapper } from "./styled";


export const LogsTableDropdown = ({ id, options, selectedOption, onSelectOption }) => {
  return (
    <LogsTableDropdownWrapper>
      <DropdownInput
        id={id}
        options={options}
        selectedOption={selectedOption}
        onSelectOption={(id) => onSelectOption(options.find((opt) => opt.id === id))}
      />
    </LogsTableDropdownWrapper>
  );
};

LogsTableDropdown.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedOption: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    value: PropTypes.string.isRequired
  }),
  onSelectOption: PropTypes.func.isRequired
};
